import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isOpen: false
}

export const modalSlice = createSlice({
    name: 'modal',
    initialState,
    reducers: {
      openModal: (state) => {
        state.isOpen = true
      },
      closeModal: (state) => {
        state.isOpen = false
      },
    },
  })

// Action creators are generated for each case reducer function
export const { openModal, closeModal } = modalSlice.actions

export default modalSlice.reducer